import React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

import {
  CategoryItem,
  CategoryList,
  LetterHeader,
} from './CategorySideMenu.styles'

import 'react-loading-skeleton/dist/skeleton.css'

export const CategorySideMenuSkeleton: React.FC = () => (
  <SkeletonTheme
    baseColor="rgba(150,150,150, 0.1)"
    highlightColor="rgba(255,255,255, 0.1)"
    enableAnimation={false}
  >
    <CategoryList>
      {Array(2)
        .fill(0)
        .map((_, i) => (
          <CategoryItem key={i}>
            <Skeleton width={150} height={20} />
          </CategoryItem>
        ))}
    </CategoryList>

    <LetterHeader>
      <Skeleton width={25} height={20} />
    </LetterHeader>
    <CategoryList>
      {Array(3)
        .fill(0)
        .map((_, i) => (
          <CategoryItem key={i}>
            <Skeleton width={150} height={20} />
          </CategoryItem>
        ))}
    </CategoryList>

    <LetterHeader>
      <Skeleton width={25} height={20} />
    </LetterHeader>
    <CategoryList>
      {Array(4)
        .fill(0)
        .map((_, i) => (
          <CategoryItem key={i}>
            <Skeleton width={150} height={20} />
          </CategoryItem>
        ))}
    </CategoryList>

    <LetterHeader>
      <Skeleton width={25} height={20} />
    </LetterHeader>
    <CategoryList>
      {Array(6)
        .fill(0)
        .map((_, i) => (
          <CategoryItem key={i}>
            <Skeleton width={150} height={20} />
          </CategoryItem>
        ))}
    </CategoryList>
  </SkeletonTheme>
)
